export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/PakFlag.dbe0f678.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};